var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('SearchForm', {
    on: {
      "submit": function submit($event) {
        return _vm.submit($event);
      }
    }
  }), _vm.formData.terms ? _c('SearchResults', _vm._b({}, 'SearchResults', _vm.formData, false)) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }